import React from "react";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import models from "../../constants/models";
import { app } from "../../services";
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import CatalogsIconButton from "../customForms/CatalogsIconButton";
import { isObject } from "superagent/lib/utils";

export default function SearchSelectMultiple({
  id,
  field,
  item = {},
  childrens,
  setButtonRemove = () => {},
  ownerName = null,
}) {
  const model = Object.values(models).find((e) => e.id === field?.relation?.id_model) || {};
  const user = useSelector((state) => state.session.globalUser);
  const institution = useSelector((state) => state.session.institution);
  const service = app.service(field?.relation?.vc_nameTable);
  const theme = useTheme();

  const [itemRemove, setItemRemove] = React.useState(null);
  const [errorItems, setErrorItems] = React.useState(null);
  const [childrensInner, setChildrensInner] = React.useState([]);

  const isAdmin = institution?.roles?.find(
    (e) =>
      e.id_rol === "cab3b86a-09db-4808-85ff-bc235fd7b6f9" ||
      e.id_rol === "663536e2-bdb4-4887-a313-c42d3e00bc37"
  );

  // ✅ control de concurrencia
  const abortRef = React.useRef(null);
  const seqRef = React.useRef(0);

  React.useEffect(() => {
    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, []);

  const buildAndFilters = () => {
    const filtersDefault = [];

    (model?.defaultSystem || []).forEach((it) => {
      switch (true) {
        case it.param === "institution":
          filtersDefault.push({ [it.vc_field]: institution?.[it.key] });
          break;
        case it.param === "user":
          filtersDefault.push({ [it.vc_field]: user?.[it.key] });
          break;
        case it.type === "static":
          filtersDefault.push({ [it.vc_field]: it.value });
          break;
        default:
          break;
      }
    });

    let validation = true;

    (field?.relation?.defaultSystem || []).forEach((it) => {
      switch (true) {
        case it.param === "institution":
          filtersDefault.push({ [it.vc_field]: institution?.[it.key] });
          break;
        case it.param === "user":
          filtersDefault.push({ [it.vc_field]: user?.[it.key] });
          break;
        case it.type === "static":
          filtersDefault.push({ [it.vc_field]: it.value });
          break;
        case it.type === "field": {
          const el = document.getElementById(it.key);
          if (el?.value !== undefined && el?.value !== "" && el?.value !== null) {
            filtersDefault.push({ [it.vc_field]: el.value });
          } else if (it.required) validation = false;
          break;
        }
        default:
          break;
      }
    });

    const and = [...(model?.and || []), ...filtersDefault];
    return { and, validation };
  };

  const getDataBase = async () => {
    if (!item[field?.relation?.keyItem]) return;

    // ✅ cancela anterior
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    const mySeq = ++seqRef.current;

    const { and, validation } = buildAndFilters();
    if (!validation) return;

    try {
      const response = await service.find({
        query: {
          $limit: 200,
          $skip: 0,
          $and: [
            ...(and || []),
            { [field?.relation?.foreignKey]: item[field?.relation?.keyItem] },
          ],
        },
        // Nota: Feathers no usa signal aquí, pero la concurrencia la controlamos con seqRef
      });

      // ✅ ignora respuesta vieja
      if (mySeq !== seqRef.current) return;

      setButtonRemove({ [field.id]: response?.data || [] });
      setChildrensInner(response?.data || []);
    } catch (e) {
      // si cancelaste o hubo error, no revientas UI
    }
  };

  React.useEffect(() => {
    if (childrens === undefined) getDataBase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childrens]);

  const handleDelete = async () => {
    let query = {};
    Object.keys(itemRemove || {}).forEach((key) => {
      if (!isObject(itemRemove[key])) query[key] = itemRemove[key];
    });

    try {
      await service.remove(itemRemove.id || null, itemRemove.id ? undefined : { query });
      await getDataBase();
      setItemRemove(null);
    } catch (error) {
      setErrorItems({
        title: "¡Ups!",
        fields: error?.errors?.map((e) => ({ label: e.message })) || [{ label: error?.message || "Error" }],
      });
    }
  };

  const getLabel = (it) => {
    let label = "";
    if (!it) return "";
    field?.relation?.fieldsDisplay?.forEach((key, index) => {
      label = `${label}${(field?.relation?.objectPath ? (it[field?.relation?.objectPath] || {})[key] : it[key]) || ""}${
        field?.relation?.fieldsDisplaySeparators?.[index] || ""
      }`;
    });
    return label;
  };

  return [
    <Box key={"icon"} margin={1} flexDirection={"row"} display={"flex"} justifyContent={"stretch"}>
      <Typography>{field.label}</Typography>

      {isAdmin && !!item[field?.relation?.keyItem] && (
        <CatalogsIconButton
          onSaveNotify={getDataBase}
          model={{
            ...model,
            defaultValues: {
              ...model.defaultValues,
              [field?.relation?.foreignKey]: item[field?.relation?.keyItem],
            },
            columns: (model?.columns || []).filter((e) => e.id !== field?.relation?.foreignKey),
          }}
          backgroundColor={"transparent"}
          sizeButton={"small"}
          size={20}
          color={theme.palette.mode === "light" ? "black" : "white"}
          icon={"assets/icons/add.svg"}
        />
      )}
    </Box>,

    <Box
      key={"childs"}
      style={{
        backgroundColor: "rgba(200,200,200,0.1)",
        padding: 4,
        boxShadow: "0px 0px 2px gray",
        borderRadius: 10,
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap",
      }}
    >
      {childrensInner.map((child, index) => {
        const labelChip = getLabel(child) || "";
        return (
          <CatalogsIconButton
            key={index}
            ownerName={ownerName}
            onSaveNotify={getDataBase}
            model={{
              ...model,
              defaultValues: {
                ...model.defaultValues,
                [field?.relation?.foreignKey]: item[field?.relation?.keyItem],
              },
              columns: (model?.columns || []).filter((e) => e.id !== field?.relation?.foreignKey),
            }}
            item={child}
            mode="component"
            component={
              <Chip
                style={{ margin: 4 }}
                label={labelChip}
                onDelete={isAdmin ? () => setItemRemove(child) : undefined}
              />
            }
            backgroundColor={"transparent"}
            sizeButton={"small"}
            size={20}
            color={theme.palette.mode === "light" ? "black" : "white"}
            icon={"assets/icons/add.svg"}
          />
        );
      })}

      {childrensInner.length === 0 && <Button fullWidth>{`Sin registros`}</Button>}
    </Box>,

    <Dialog key={"validation"} open={!!itemRemove} onClose={() => setItemRemove(null)}>
      <DialogTitle>{"Eliminar"}</DialogTitle>
      <DialogContent>
        <DialogContentText>{`¿Seguro que desea eliminar ${getLabel(itemRemove)}?`}</DialogContentText>
        <DialogActions>
          <Button onClick={() => setItemRemove(null)}>{"Cancelar"}</Button>
          <Button onClick={handleDelete}>{"Eliminar"}</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>,

    <Dialog key={"error"} open={!!errorItems} onClose={() => setErrorItems(null)}>
      <DialogTitle>{errorItems?.title}</DialogTitle>
      <DialogContent>
        {errorItems?.fields?.map((it, i) => (
          <Typography key={i}>{it.label}</Typography>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setErrorItems(null)}>{"Aceptar"}</Button>
      </DialogActions>
    </Dialog>,
  ];
}
